import React, { useState, useEffect } from 'react';
import { Tenant } from '../../services/tenantService';
import './TenantForm.css';

interface TenantFormProps {
  tenant?: Tenant | null;
  onSubmit: (data: { nomTenant: string; chaineConnexion: string }) => void;
  onCancel: () => void;
}

const TenantForm: React.FC<TenantFormProps> = ({ tenant, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    nomTenant: '',
    chaineConnexion: ''
  });

  useEffect(() => {
    if (tenant) {
      setFormData({
        nomTenant: tenant.nomTenant || '',
        chaineConnexion: tenant.chaineConnexion || ''
      });
    }
  }, [tenant]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.nomTenant.trim() && formData.chaineConnexion.trim()) {
      onSubmit(formData);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="tenant-form-overlay">
      <div className="tenant-form">
        <h3>{tenant ? 'Modifier le Tenant' : 'Nouveau Tenant'}</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nomTenant">Nom du Tenant *</label>
            <input
              type="text"
              id="nomTenant"
              name="nomTenant"
              value={formData.nomTenant}
              onChange={handleChange}
              required
              placeholder="Entrez le nom du tenant"
            />
          </div>

          <div className="form-group">
            <label htmlFor="chaineConnexion">Chaîne de Connexion *</label>
            <textarea
              id="chaineConnexion"
              name="chaineConnexion"
              value={formData.chaineConnexion}
              onChange={handleChange}
              required
              rows={3}
              placeholder="Entrez la chaîne de connexion à la base de données"
            />
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn btn-secondary">
              Annuler
            </button>
            <button type="submit" className="btn btn-primary">
              {tenant ? 'Mettre à jour' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TenantForm;

